import { createFileRoute } from '@tanstack/react-router'
import { WorkWithUsPage } from '@/components/engineering/EngineeringPages'
import { localizedPageHead } from '@/lib/seo-head'

export const Route = createFileRoute('/{-$locale}/work-with-us')({
  head: ({ params }) => localizedPageHead('workWithUs', params.locale),
  component: () => <WorkWithUsPage />,
})
